<template>
  <div class="headerFrame" @mouseover="handleOverHeader" @mouseleave="handleLeaveHeader">
    <div class="header">
      <div :style="{position: 'absolute', left: '0px', top: '3px'}">
        <div v-for="index in 100" :key="index">
          <Triangle :faceSize="23" :indexX="index" :indexY="0" />
          <Triangle :faceSize="23" :indexX="index" :indexY="1" />
          <Triangle :faceSize="23" :indexX="index" :indexY="2" />
          <Triangle :faceSize="23" :indexX="index" :indexY="3" />
          <Triangle :faceSize="23" :indexX="index" :indexY="4" />
        </div>
      </div>

      <div class="headerTitle" @click="home()">MadSci Lab Blog</div>
      
      <div class="headerLinks" v-if="!this.tIsMobile">
        <span class="aboutLink">
          <a
            href="#"
            @click="toggleHeaderSize()"
            class
            v-if="this.init"
          >{{this.headerOpen ? "less" : "about"}}</a>
        </span>
        <a href="#" @click="setCategoryFilter(-1)" :style="getLinkStyle(-1)">All</a> |
        <a href="#" @click="setCategoryFilter(0)" :style="getLinkStyle(0)">Projects & Events</a> |
        <a href="#" @click="setCategoryFilter(1)" :style="getLinkStyle(1)">Agency work</a> |
        <a href="#" @click="setCategoryFilter(2)" :style="getLinkStyle(2)">Research & Experiments</a>
      </div>

      <div class="headerLinks" v-if="this.tIsMobile">
        <span class="aboutLink">
          <a
            href="#"
            @click="toggleHeaderSize()"
            class
            v-if="this.init"
          >{{this.headerOpen ? "less" : "about"}}</a>
        </span>
     </div>

      <div class="headerSubtitle" :style="getSubtitleWidth">
        The Madsci Lab is an multi-disciplinary research and design group within the Havas New York office, focusing on creative applications of technology.
        <a
          href="#"
          @click="selectIntro()"
        >more ></a>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import { EventBus } from "@/event-bus.js";
import Triangle from "@/components/Triangle.vue";

import { isMobile } from 'mobile-device-detect'

export default {
  components: { Triangle },
  methods: {

    selectIntro() {
      EventBus.$emit("select-project", 33);
    },

    home() {
      EventBus.$emit("go-home", true);
    },
    setCategoryFilter(_f) {
      this.selectedFilter = _f;
      EventBus.$emit("set-filter", _f);
    },
    closeHeaderSize() {

      console.log("*** close header " + this.headerOpen)
      this.init = true;

      gsap.to(".header", {
        duration: 0.4,
        height: this.headerOpen ? this.openSize : this.closedSize,
      });
    },
    toggleHeaderSize() {
      this.headerOpen = !this.headerOpen;
      //EventBus.$emit("close-nav", this.headerOpen);

      this.closeHeaderSize();
    },
    handleOverHeader: function () {
      this.isOver = true;
    },
    handleLeaveHeader: function () {
      this.isOver = false;
    },
    getLinkStyle: function (_index) {
      var _c = {
        width: "195px",
        borderBottom: "solid 2px #ffffff",
        padding: "0px",
      };
      if (_index == this.selectedFilter) {
        switch (this.selectedFilter) {
          case -1:
            _c = {
              borderBottom: "solid 2px #000000aa",
              width: "150px",
              padding: "0px",
            };
            break;
          case 0:
            _c = {
              borderBottom: "solid 2px #00bb00",
              width: "150px",
              padding: "0px",
            };
            break;
          case 1:
            _c = {
              borderBottom: "solid 2px #eeee00",
              width: "120px",
              padding: "0px",
            };
            break;
          case 2:
            _c = {
              width: "195px",
              borderBottom: "solid 2px #000000aa",
              padding: "0px",
            };
            break;
        }
      }
      return _c;
    },
  },
  props: {
  },
  computed: {

    getSubtitleWidth: function() {

      return {
        width: this.tIsMobile ? "90%" : '532px',
        fontSize: this.tIsMobile ? '12px' : '15px'
      }
    },

    isMobile: function() {
      return true;
    },
    getHeader: function () {
      return "header";
    },
  },
  mounted() {

    //this.toggleHeaderSize()

    this.rotateInterval = setInterval(() => {
        console.log("rot");
        this.rotateAllImages();
    }, 1000);

  },

  created() {
    EventBus.$on("set-nav", (_on) => {

      //console.log("*** SET NAV " + _on + " cur nav : " + this.headerOpen)

      if (_on != this.headerOpen) {
        //if (_on || this.init == false) {
          this.headerOpen = _on
          this.closeHeaderSize(_on);
        //}
      }

    });
    EventBus.$on("set-nav-filter", (_f) => {
      this.selectedFilter = _f;
    });
  },
  data() {
    return {
      headerOpen: true,
      isOver: true,
      selectedFilter: -1,
      closedSize: 49,
      openSize: 120,

      init: false,

      tIsMobile: isMobile ? true : false,
    };
  },
};
</script>

<style>
.aboutLink {
  padding-right: 15px;
  padding-bottom: 2px;
}

.aboutLink a {
  color: #00bb00;
}

.header {
  width: 99vw;
  border: solid 1px #33333366;
  height: 120px;
  position: relative;
  overflow: hidden;
  z-index: 10;
  background-color: #ffffff;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.06), 0 2px 2px rgba(0, 0, 0, 0.06);
}

.headerSwitch {
  position: absolute;
  font-size: 18px;
  font-weight: 700;
  top: 14px;
  left: 133px;
  width: 10px;
  text-align: center;
}

.headerTitle {
  padding: 15px;
  font-weight: 700;
  width: 201px;
  position: relative;
  height: 19px;
  background-color: #ffffff;
  cursor: pointer;
}

.headerSubtitle {
  padding: 5px;
  padding-top: 10px;
  padding-left: 15px;
  font-weight: 500;
  
  line-height: 1.3;
  top: 48px;
  left: 0px;
  position: absolute;
  height: 60px;
  overflow: hidden;
  color: #444444;
  background-color: #ffffff;
  --border: solid 1px #00ff00;
}

.headerSubtitle a {
  font-size: 16px;
  color: #00bb00;
}

.headerLinks {
  font-size: 14px;
  position: absolute;
  right: 0px;
  padding-right: 20px;
  padding-left: 15px;
  padding-top: 17px;
  top: 0px;
  height: 32px;
  background-color: #ffffff;
}

.headerLinks a {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.1;
}

.headerLinks a:hover {
  text-decoration: none;
}

.headerFrame {
  position: relative;
  z-index: 10;
  top: 0px;
  left: 0px;
  width: 100%;
  padding: 0px;
  background-color: #ffffff;
  text-align: left;
  font-size: 20px;
}
</style>